module.exports = __webpack_public_path__ + "images/Thumbs down - fillbf9d53b06d8f0593b40705df7eb6a913.svg";